export default class Node {

    /** 弹窗列表 */
    public popList:Pop[] = [];
}

export class Pop{

    /** 显示组件 */
    public Components: JSX.Element = null;

    /** 标题 */
    public title: string | JSX.Element;

    /** 是否隐藏 */
    public isHide: boolean;

    /** 宽 */
    public width: number;
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/rightPopUps/Node.ts